const removeTrailingSlashes = (str: string): string => str.replace(/\/+$/g, '')

export const assetCdnHost = () => {
  const DEFAULT_VALUE = ''

  if (!window) {
    return DEFAULT_VALUE
  }

  if (typeof window.ASSET_CDN_HOST !== 'string') {
    return DEFAULT_VALUE
  }

  return removeTrailingSlashes(window.ASSET_CDN_HOST)
}
